// @flow
export default {
    toFixed: (number:number, decimals:number)=>{
        return parseFloat(number.toFixed(decimals));
    }
}